import { NavCardsSection } from "./section-list";
import { useSimpliCity } from "@simplicitycms/simplicity-common";

const NavCardsComponent = (props) => {
    const { component } = props;
    const { webpage } = useSimpliCity();
    
    return (
        <div>
            {/*Navigation Cards Component Display*/}
            <NavCardsSection
                component={component}
                webpage={webpage}
            />
        </div>
    );
};
NavCardsComponent.displayName = "NavCardsComponent";
export { NavCardsComponent }; 
